// @ts-nocheck
import { addListener } from "~/lib/signals";
import Scene from "~/scene";
import List from "~/places/list";
import { isDetailActive } from "~/util/detail";
import { store } from "~/state/store";
import { node } from "~/util/dom";

export default class DetailComp {
	constructor(owner) {
		this._owner = owner;
		this._dom = {
			container: node("div", { className: "places-detail" }),
		};
		this._list = new List({
			isDetail: true,
			owner: this._owner,
		});
		this._dom.list = this._list.getContainer();
		this._mymaps = null;
		this._active = false;
		this._folderId = "";

		this._dom.container.appendChild(this._dom.list);

		addListener(this, "detail-activated", () => {
			this._list.activeDetail(true);
		});

		addListener(this, "detail-deactivated", () => {
			this._list.activeDetail(false);
		});
	}

	clear() {
		this._list.lookup.clean();
	}

	get active() {
		return this._active;
	}

	get shareData() {
		return this._list.shareData;
	}

	get folderId() {
		return this._folderId;
	}

	changePublic(state) {
		this._list.shareData.public = state;
	}

	notifyLikeCreate(folderId) {
		if (this._active && folderId === this._folderId) {
			this._list.clean();
			this._list.load();
		}
	}

	notifyLikeUpdate() {
		Mapy.getComponent("places").detailLock = true;
		this._list.clean();
		this._list.load().finally(() => {
			Mapy.getComponent("places").detailLock = false;
		});
		this._active && this._list.lookup.lookup();
	}

	activate() {
		if (this._active) {
			return;
		}

		if (!this._mymaps) {
			this._mymaps = Mapy.getComponent("mymaps");
		}

		this._owner.container.appendChild(this._dom.container);
		this._list.lookup.start();

		Scene.getContainer().addEventListener("photo-gallery-close", this);
		Scene.getContainer().addEventListener("photo-detail-close", this);

		this._active = true;
		this._list.active = this._active;
	}

	deactivate() {
		if (!this._active) {
			return;
		}

		this._dom.container.remove();

		this._list.setFolderId();
		this._list.clean();
		this._list.lookup.stop();

		Scene.getContainer().removeEventListener("photo-gallery-close", this);
		Scene.getContainer().removeEventListener("photo-detail-close", this);

		this._active = false;
		this._list.active = this._active;
	}

	set state(state) {
		this._folderId = state.mid;

		if (state.detailType) {
			// true - history replace
			this._list.loadItemDetail(this._folderId, state.detailType, true);
		} else {
			this._list.setFolderId(this._folderId);
			this._list.setFolderTitle(state.folderTitle);
			this._list.setFolderTotalInfo(0, 0);
			this._list.load().then(() => {
				if (isDetailActive(store.getState())) {
					this._list.activeDetail(true);
				}

				if (state.zoomToItems) {
					this._list.zoomToItems();
				} else {
					this._list.lookup.lookup();
				}
			}, () => {});
		}
	}

	refresh() {
		this._list.setMultipleMode(false);
	}

	activeSetState(opts: { refreshOnActivate: boolean; }) {
		this._list.setMultipleMode(false);

		if (opts.refreshOnActivate) {
			this._list.clean();
			this._list.load();
		}
	}

	handleEvent(event) {
		if (event.type === "photo-detail-close" || event.type === "photo-gallery-close") {
			this._active && !Mapy.getComponent("gallery").isActive() && this._list.setSEO();
		}
	}

	highlightItem(id) {
		this._list.highlightById(id);
	}
}
